import type { User, Role, Invitation } from '@conversia/shared-types';
import type { Paginated } from '@/lib/types';
import { api } from './client';

/** Endpoints de usuarios e invitaciones (ADMIN). Prefijo: /api/users */

export interface ListUsersParams {
  role?: Role;
  isActive?: boolean;
  search?: string;
  skip?: number;
  take?: number;
}

export const listUsers = (params: ListUsersParams = {}) =>
  api.get<Paginated<User>>('/api/users', { query: params });

export const getUser = (id: string) => api.get<User>(`/api/users/${id}`);

export const updateRole = (id: string, role: Role) =>
  api.post<User>(`/api/users/${id}/role`, { role });

export const deactivate = (id: string) => api.del<User>(`/api/users/${id}`);

/** Reactiva un usuario desactivado (la desactivación es un soft-delete). */
export const reactivate = (id: string) => api.patch<User>(`/api/users/${id}`, { isActive: true });

/** Edita nombre y/o email (rediseño /users: corregir typos sin recrear la cuenta). */
export const updateUser = (id: string, input: { name?: string; email?: string }) =>
  api.patch<User>(`/api/users/${id}`, input);

export const listInvitations = (all = false) =>
  api.get<Invitation[]>('/api/users/invitations', { query: { all: all ? 'true' : undefined } });

export const invite = (input: { email: string; role: Role }) =>
  api.post<Invitation>('/api/users/invitations', input);

export const revokeInvitation = (id: string) =>
  api.del<{ success: boolean }>(`/api/users/invitations/${id}`);

/** Reset por admin: devuelve la clave temporal (se muestra UNA sola vez). */
export const adminResetPassword = (id: string) =>
  api.post<{ tempPassword: string }>(`/api/users/${id}/password`);
